module.exports = __webpack_public_path__ + "img/product_84.5a54db9.webp";